import base from './base';

const primaryColor = '#0090d2';
const primary = '#0090d2';
const hover = '#6aacc0';
const errorColor = '#d71f28';

const hum7 = base({primaryColor, primary, hover, errorColor, base});
hum7.title.showInBody = false;
hum7.title.color = '#fff';
hum7.title.backgroundColor = primary;
hum7.title.height = '65px';
hum7.progressBar.height = '65px';
hum7.progressBar.useProgressTabs = false;
hum7.progressBar.step1of2 = undefined;
hum7.progressBar.step2of2 = undefined;
hum7.teaser.sidebarMarginTopWide = '400px';
hum7.marginBottom = '10px';
hum7.formLayout = {...hum7.formLayout, gap: '10px'};

export default hum7;
